export const env = "";
export const base_path = "";
export const image_path =''
export const base_api_url="https://api.qrnyama.com/";
export const base_ui_url="https://app.qrnyama.com/";
export const DEFAULT_STRIPE_SECRET_KEY = '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';
export const DEFAULT_STRIPE_PUBLIC_KEY = 'pk_live_51SeieOHV3Op54u4Lu6tuDnQokObRLSbQTjpvCwYnDeLwZEyUYBTgDNhAoyjcThkuDg4nb47bIBHKu6rvefLD7rpf00ed18sUfj';
export const SKIP_SUBSCRIPTION_CHECK = true;
